export default __webpack_public_path__ + "static/media/folder-view.5c25b8b0.svg";